import React, { useState, useRef } from "react";
import axios from "axios";
import { main_link } from "../Connection/Connection";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import Form from "react-bootstrap/Form";
import { Toast } from "primereact/toast";
//
function SendAReminder(props) {
  const toast = useRef(null);
  const show = props.show;
  const setShow = props.setShow;
  const details = props.details;
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const [loading, setLoading] = useState(false);

  const [name, setName] = useState(details.name);
  const [mobile, setMoblie] = useState(details.mobile);

  const sendSMS = async (e) => {
    e.preventDefault();
    setLoading(true);
    const user = JSON.parse(sessionStorage.getItem("user-data"));
    const user_id = user["encrypted_id"];

    try {
      const response = await axios.post(main_link + "sendAReminderSMS", {
        user_id,
        name,
        mobile,
        details,
      });
      setLoading(false);
      console.log(response.data);
      if (response.data.message == "Added Successfully.") {
        toast.current.show({
          severity: "success",
          summary: "success",
          detail: "Added Successfully.",
        });
      }
    } catch (error) {
      console.log(error);
      setLoading(false);
    }

    setLoading(false);
  };

  return (
    <>
      <Modal show={show} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>Send {details.name} A Reminder SMS</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {" "}
          <Form.Label htmlFor="inputPassword5">Name</Form.Label>
          <Form.Control
            type="text"
            id="name"
            aria-describedby="name"
            defaultValue={details.name}
            onChange={(e) => setName(e.target.value)}
          />
          <Form.Label htmlFor="inputPassword5">Phone</Form.Label>
          <Form.Control
            type="text"
            id="name"
            aria-describedby="name"
            defaultValue={details.mobile}
            onChange={(e) => setMoblie(e.target.value)}
          />
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Close
          </Button>
          {loading && (
            <Button variant="primary" disabled>
              Sending...
            </Button>
          )}
          {!loading && (
            <Button variant="primary" onClick={(e) => sendSMS(e)}>
              Send
            </Button>
          )}
        </Modal.Footer>
      </Modal>
    </>
  );
}

export default SendAReminder;
